<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <!--        <v-flex xs12 sm12 md6 v-if="item">-->
        <!--          -->
        <!--        </v-flex>-->
        <v-flex xs12 sm12 md6>
<!--          item images-->
          <v-card v-if="item" class="elevation-0 mx-auto" >
            <v-carousel
                height="500"
                cycle
                hide-delimiter-background
                show-arrows-on-hover
            >
              <v-carousel-item
                  v-for="img in item.imgs"
                  :key="img.id"
                  :src="img.url"
                  @click="openItemImage(img)"
              >
                <!--                        @click="imageSelected(img.id)"-->
              </v-carousel-item>
              <v-img
                  v-if="item.imgs.length === 0"
                  height="400"
                  src="https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2FImage%20Placeholder.png?alt=media&token=b21de5eb-9239-4f64-a558-31d69e9d0726"
              ></v-img>
            </v-carousel>
          </v-card>
          <v-divider class="mt-2"></v-divider>
          <div class="font-weight-light" v-if="itemVariations.length > 1">Other options: </div>
<!--          other options-->
          <v-slide-group
              show-arrows
              v-if="itemVariations.length > 1"
          >
            <v-slide-item
                v-for="option in itemVariations"
                :key="option.id"
                v-slot="{ active }"
            >
              <v-card
                  :color="active ? undefined : 'grey lighten-5'"
                  class="elevation-1 ma-1"
                  height="80"
                  width="80"
                  tile
                  @click="changeItemVarient(option)"
              >
<!--                <v-row-->
<!--                    class="fill-height"-->
<!--                    align="center"-->
<!--                    justify="center"-->
<!--                >-->
                  <v-img v-if="option.imgs.length !== 0"
                         height="60" :src="option.imgs[0].url">
                  </v-img>
                  <v-img v-else
                         height="60"
                         src="https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2FImage%20Placeholder.png?alt=media&token=b21de5eb-9239-4f64-a558-31d69e9d0726"
                  >
                    <v-card-title></v-card-title>
                  </v-img>
                  <div class="ml-4">${{option.baseRate}}</div>
              </v-card>

            </v-slide-item>
          </v-slide-group>
          <v-divider v-if="itemVariations.length > 1" class="mt-2"></v-divider>
<!--          Title, Prices, short description descriptions-->
          <v-card v-if="item" class="elevation-0 mx-auto">
<!--            item title-->
            <v-card-title class="headline pb-0" style="word-break: break-word">{{item.title}}</v-card-title>
<!--            display only-->
            <div v-if="displayOnly">
              <!--            Short description-->
              <v-card-subtitle>
                <div class="body-1">{{item.shortDescription}}</div>
              </v-card-subtitle>
            </div>
<!--            show price-->
            <div v-if="!displayOnly">
              <!--            products-->
              <div v-if="item.itemType === 'product'">
<!--                ${{totalEstimate}}-->
                <h2 class="ml-4 font-weight-regular" v-if="itemCategory === 'productWithPickup'">
                  ${{totalEstimate}}
                </h2>
                <div v-else>
                  <h2 class="ml-4 font-weight-regular" v-if="totalEstimate > 0">
                    ${{totalEstimate}}
                  </h2>
                  <h3 class="ml-4 font-weight-regular" v-else>
                    ${{item.baseRate}} <span v-if="item.additionalFeesLabel !== ''"> + {{item.additionalFeesLabel}}</span>
                  </h3>
                </div>
                <!--            Short description-->
                <v-card-subtitle>
                  <div class="body-1">{{item.shortDescription}}</div>
                </v-card-subtitle>
                <v-flex xs2 sm2 md2 lg2 class="ml-3" >
                  <div>Quantity:</div>
                  <v-text-field
                      v-model="item.qty"
                      label="Quantity"
                      type="number"
                      dense
                      solo
                      placeholder="1"
                      min="1"
                      max="100"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="item" xs6 sm6 md6 lg6 class="ml-3">
                  <v-switch
                      v-if="item.pickUpDeliveryOptional && !item.onlineOnly"
                      v-model="pickUpItemSwitch"
                      label="Pick up Item"
                      color="blue"
                  ></v-switch>
                </v-flex>
                <!--              locations-->
                <!--            pickup location-->
                <v-card-text v-if="(itemCategory === 'productWithPickup')
                                || (itemCategory === 'onlineOnly')">
                  <!--Location field title-->
                  <v-flex class="mt-2" xs12 sm12 v-if="itemCategory === 'productWithPickup'">
                    <div>Pickup location:</div>
                    <h3 class="font-weight-regular" v-if="item.startingLocations.length > 0">
                      <v-icon class="green--text">pin_drop</v-icon>
                      {{locationCountryRemoved(item.startingLocations[0].formatted_address)}}
                    </h3>
                  </v-flex>
                  <v-flex class="mt-2" xs12 sm12 v-if="itemCategory === 'onlineOnly'">
                    <h3 class="font-weight-regular">
                      <v-icon class="green--text">check_circle</v-icon>
                      Available Online
                    </h3>
                  </v-flex>

                </v-card-text>
                <!--              product with delivery-->
                <v-card-text v-if="((itemCategory === 'productWithDelivery')
                                  || (itemCategory === 'productWithMultipleStop'))">
                  <!--Location field title-->
                  <v-flex class="mb-5" xs12 sm12 v-if="!deliveryLocation">
                    <h3 class="font-weight-regular">
                      {{item.locationLabel}}
                    </h3>
                  </v-flex>
                  <!--           delivery location formatted_address-->
                  <v-flex v-if="deliveryLocation" xs12 sm12 md12>
                    <!--First Location Found-->
                    <div class="subtitle-2">
                      {{item.locationLabel}}
                    </div>
                    <div class="subtitle-2 mb-2" >
                      <v-icon>pin_drop</v-icon>
                      {{locationCountryRemoved(deliveryLocation.formatted_address)}}
                      <v-icon @click="removeFirstLocation()" class="red--text">close</v-icon>
                    </div>
                  </v-flex>
                  <v-layout  v-if="!deliveryLocation" row>
                    <v-flex class="pl-4" xs12 sm12 md12>
                      <!--First Location-->
                      <locations-autocomplete  @locationFound="setFirstLocation"></locations-autocomplete>
                      <v-divider  class="mb-5"></v-divider>
                    </v-flex>
                  </v-layout>
                  <!--                multiple locations-->
                  <v-expansion-panels v-if="itemCategory === 'productWithMultipleStop'"
                                      multiple
                                      class="pt-8">
                    <!--             additional locations-->
                    <v-expansion-panel class="elevation-0" v-if="deliveryLocation">
                      <v-expansion-panel-header>
                        <h4 class="font-weight-regular">Add more {{item.locationLabel}}</h4>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content >
                        <v-flex xs12 sm12 md12>
                          <!-- add more locations-->
                          <v-list>

                            <!--additional Location-->
                            <div class="subtitle-2 font-weight-regular pb-5" v-for="location in additionalLocations" :key="location.created">
                              <v-icon >pin_drop</v-icon>
                              {{locationCountryRemoved(location.formatted_address)}}
                              <v-icon @click="removeAdditionalLocation(location)"
                                      class="red--text">close</v-icon>
                            </div>
                            <locations-autocomplete  @locationFound="addMoreLocations"></locations-autocomplete>
                            <v-divider  class="mb-5"></v-divider>

                          </v-list>
                        </v-flex>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
                <!--Action buttons-->
                <v-card-text class="pt-6">
                  <!--                <v-spacer></v-spacer>-->
                  <v-btn block @click="saveToMyList()" outlined class="blue--text">
                    Save to my list
                  </v-btn>
                  <v-btn block @click="bookOrderDirect" class="blue mt-2" dark text>
                    Order now
                  </v-btn>
                </v-card-text>
              </div>
              <!--            services-->
              <div v-if="item.itemType === 'service'">
                <!--            starting price-->
                <div v-if="itemCategory === 'serviceAtBaseRate'">
                  <h3 class="ml-4 font-weight-regular">
                    Starting from ${{Number(item.baseRate).toFixed(2)}}
                  </h3>
                </div>
                <!--            starting price-->
                <div v-if="!(itemCategory === 'serviceAtBaseRate') && !totalEstimate">
                  <h3 class="ml-4 font-weight-regular">
                    Starting from ${{Number(item.baseRate).toFixed(2)}}
                  </h3>
                </div>
                <!--            Short description-->
                <v-card-subtitle>
                  <div class="body-1">{{item.shortDescription}}</div>
                </v-card-subtitle>

                <!--            total estimate with travel time and multiple stops-->
                <v-card-text v-if="!(itemCategory === 'serviceAtBaseRate') && (totalEstimate > 0)">
                  <div class="pl-2 pt-3 display-1">
                    ${{totalEstimate}}
                  </div>
                  <div class="subtitle-1 pl-4 pt-2">
                    Distance Included: {{formattedTimeAndDistance.totalDistance}}
                  </div>
                  <div class="subtitle-1 pl-4">
                    Estimated Duration: {{formattedTimeAndDistance.totalHours}} *
                  </div>
                </v-card-text>


                <!--            locations-->
                <!--            travel distance locations-->
                <v-card-text
                    v-if="(itemCategory === 'serviceWithTravelTime')
                    || (itemCategory === 'serviceWithMultipleStop')">
                  <!--Location field title-->
                  <v-flex class="mb-5" xs12 sm12 v-if="!deliveryLocation">
                    <h3 class="font-weight-regular">
                      {{item.locationLabel}}
                    </h3>
                  </v-flex>
                  <!--           delivery location formatted_address-->
                  <v-flex v-if="deliveryLocation" xs12 sm12 md12>
                    <!--First Location Found-->
                    <div class="subtitle-2">
                      {{item.locationLabel}}
                    </div>
                    <div class="subtitle-2">
                      <v-icon>pin_drop</v-icon>
                      {{locationCountryRemoved(deliveryLocation.formatted_address)}}
                      <v-icon @click="removeFirstLocation()" class="red--text">close</v-icon>
                    </div>
                  </v-flex>
                  <!--                  search first address-->
                  <v-layout row>
                    <v-flex v-if="!deliveryLocation" class="pl-4 mb-5" xs8 sm3 md3>
                      <!--First Location-->
                      <locations-autocomplete  @locationFound="setFirstLocation"></locations-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-expansion-panels multiple class="mt-5">
                    <!--             additional locations-->
                    <v-expansion-panel v-if="deliveryLocation" class="mt-3">
                      <v-expansion-panel-header v-if="itemCategory === 'serviceWithMultipleStop'">
                        <h4 class="font-weight-regular">Add more {{item.locationLabel}}</h4>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content v-if="itemCategory === 'serviceWithMultipleStop'">
                        <v-flex xs12 sm12 md12>
                          <!-- add more locations-->
                          <v-list>
                            <!--additional Location-->
                            <v-flex class="pl-4 pt-3 mb-5" xs10 sm6 md6>
                              <locations-autocomplete  @locationFound="addMoreLocations"></locations-autocomplete>
                            </v-flex>
                            <div class="subtitle-2 font-weight-regular" v-for="location in additionalLocations" :key="location.created">
                              <v-icon>pin_drop</v-icon>
                              {{locationCountryRemoved(location.formatted_address)}}
                              <v-icon @click="removeAdditionalLocation(location)"
                                      class="red--text">close</v-icon>
                            </div>
                          </v-list>
                        </v-flex>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!--                add-on items-->
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <h4 class="font-weight-regular">What's included</h4>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <!--search items-->
                        <addon-item-picker
                            :publicListingId="publicListingId"
                            :listingId="listingId"
                            @itemFound="addItem"
                        ></addon-item-picker>
                        <v-list-item v-for="addOnItem in addOnItems" :key="addOnItem.created">
                          <v-row>
                            <v-col  @click="openItemDialog(addOnItem)" cols="2">
                              {{addOnItem.qty}}
                            </v-col>
                            <v-col cols="1">
                              x
                            </v-col>
                            <v-col  @click="openItemDialog(addOnItem)" class="subtitle-1" cols="7">
                              {{addOnItem.title}}
                            </v-col>
                            <v-col cols="1">
                              <v-icon @click="removeAddOnItem(addOnItem)" class="error--text">close</v-icon>
                            </v-col>
                          </v-row>

                        </v-list-item>

                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
                <!--Action buttons-->
                <v-card-text class="pt-6">
                  <v-btn block @click="saveToMyList()" outlined text class="blue--text">
                    Save to my list
                  </v-btn>
                  <v-btn block @click="bookOrderDirect" class="blue mt-2" dark text>
                    Book now
                  </v-btn>
                </v-card-text>
              </div>
            </div>


<!--            error bar-->
            <v-card class="theme-dialog-card">
              <app-alert @dismissed="onDismissed"  v-if="error" :text="error.message"></app-alert>
              <app-loading v-if="loading"></app-loading>

            </v-card>

            <v-divider></v-divider>

<!--features list-->
            <v-card-text>
              <ul v-for="feature in item.featuresList" :key="feature.id">
                <li class="body-1">{{feature.text}}</li>
              </ul>
            </v-card-text>
<!--full item description-->
            <v-card-text>
              <div class="body-1">{{item.fullDescription}}</div>
            </v-card-text>
<!--featured images-->
            <v-card-text v-for="img in item.featuredImgs" :key="img.id">
              <v-img :src="img.url"></v-img>
            </v-card-text>
            <v-divider></v-divider>
<!--similar items-->
            <v-card-title class="headline pb-0">Explore more</v-card-title>
            <v-card-text>
              <v-slide-group
                  show-arrows
              >
                <v-slide-item
                    v-for="similarItem in similarItems"
                    :key="similarItem.id"
                    class="mr-2"
                >
                  <v-card
                      class="elevation-0 ma-3 mx-auto"
                      width="250"
                      @click="changeItemVarient(similarItem)"
                  >
                    <v-img v-if="similarItem.imgs.length !== 0"
                           height="150" :src="similarItem.imgs[0].url"></v-img>
                    <v-img v-else
                           height="150"
                           src="https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2FImage%20Placeholder.png?alt=media&token=b21de5eb-9239-4f64-a558-31d69e9d0726"
                    ></v-img>
                    <div style="word-break: break-word">{{similarItem.title}}</div>
                    <b>Starting from ${{similarItem.baseRate}}</b>

                  </v-card>
                </v-slide-item>
              </v-slide-group>

            </v-card-text>
          </v-card>
          <v-divider class="mt-2"></v-divider>
        </v-flex>
        <v-dialog v-model="itemImageDialog"
                  ref="dialog"
                  persistent
                  fullscreen
        >
          <v-container class="white" fluid fill-height>
            <v-layout row wrap justify-center>
              <v-flex xs12 sm12 md12 lg12
                      class="mt-4">
                <v-card flat v-if="selectedImage">
                  <v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="itemImageDialog = false"
                           class="red--text"
                           icon> <v-icon>close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-img
                        :src="selectedImage.url"
                        height="450px"
                        contain
                    ></v-img>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-dialog v-model="itemDialog"
                  persistent
                  max-width="500"
        >
          <v-card v-if="selectedItem">
            <v-card-title class="text-h5" style="word-break: break-word">
              {{selectedItem.title}}
              <v-spacer></v-spacer>
              <v-btn
                  text
                  icon
                  @click="itemDialog = false"
              ><v-icon class="red--text">close</v-icon></v-btn>
            </v-card-title>

            <v-card-text>
              <v-card-actions>
                <v-btn block outlined @click="selectedItem.qty++"><v-icon>add</v-icon></v-btn>
              </v-card-actions>
              <v-container fluid fill-height>
                <v-layout align-center justify-center>
                  <v-flex xs3 sm3 md3 lg3>
                    <v-text-field
                        v-model="selectedItem.qty"
                        label="Quantity"
                        type="number"
                        dense
                        solo
                        placeholder="1"
                        min="1"
                        max="100"
                        class="display-1"
                        height="60px"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-btn block outlined :disabled="selectedItem.qty <= 1" @click="selectedItem.qty--"><v-icon>remove</v-icon></v-btn>
              </v-card-actions>
            </v-card-text>

            <v-card-actions>
              <v-btn
                  color="blue"
                  block
                  outlined
                  @click="updateItems()"
              >
                ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog max-width="500" v-model="lineItemDialog">
          <v-card class="elevation-0">
            <v-card-title>My List</v-card-title>
            <v-divider></v-divider>
            <v-card-text v-if="customerLineItems">
              <div v-if="customerLineItems.length !== 0" >
                <v-list v-for="lineItem in customerLineItems" :key="lineItem.id">
                  <v-list-item two-line >
                    <v-list-item-content>
                      <v-list-item-title>{{lineItem.title}}</v-list-item-title>
                      <v-list-item-subtitle>
                          <span>
                            ${{calcLineItemCost(lineItem)}}
                          </span>
                        <span v-if="lineItem.itemType !== 'service'">
                            Qty: {{lineItem.qty}}
                          </span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn class="red--text" icon @click="removeLineItem(lineItem)"><v-icon>close</v-icon></v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
                <div class="subtitle-1">Total Cost: ${{totalListCost}}</div>
              </div>
              <div v-else class="mt-4">
                Nothing added
              </div>
            </v-card-text>
            <v-card-text v-else class="mt-4">
              <div>
                Nothing added
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="lineItemDialog = false" text>close</v-btn>
              <v-btn v-if="lineItemsSize !== 0 " :disabled="lineItemsSize === 0"  @click="bookOrder" class="blue mt-2" dark text>
                <span v-if="item.itemType === 'service'">Book now</span>
                <span v-if="item.itemType === 'product'">Order Now</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import {onSnapshot, doc, updateDoc, collection} from "firebase/firestore";
import { v1 as uuidv1 } from 'uuid';

import {getFunctions, httpsCallable} from "firebase/functions";
export default {
  props: ['publicListingId', 'listingId', 'itemId'],
  data () {
    return {
      selectedItem: null,
      itemDialog: false,
      additionalLocations: [],
      userDialog: false,
      selectedUser: null,
      deliveryLocation: null,
      addOnItems: [],
      item: null,
      itemVariations: [],
      moreVariationsDialog: false,
      searchAddOn: '',
      similarItems: [],
      filteredList: null,
      travelTimeAndDistance: null,
      pickUpItemSwitch: false,
      lineItems: [],
      customerLineItems: null,
      lineItemsSize: 0,
      lineItemDialog: false,
      itemCategory: null,
      items: null,
      displayOnly: false,
      itemImageDialog: false,
      selectedImage: null
      // Categories:
      // productWithPickup, productWithDelivery, productWithMultipleStop, onlineOnly
      // serviceAtBaseRate, serviceWithTravelTime, serviceWithMultipleStop

    }
  },
  watch: {
    pickUpItemSwitch (value) {
      this.item.pickupLocationEnabled = !!value;
      if (this.item.pickupLocationEnabled) {
        this.itemCategory = 'productWithPickup'
        if (this.item.onlineOnly) {
          this.itemCategory = 'onlineOnly'
        }
      } else {
        this.itemCategory = 'productWithDelivery'
        if (this.item.additionalLocationsEnabled){
          this.itemCategory = 'productWithMultipleStop'
        }
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    totalEstimate () {
      let total = 0
      let totalHours = 0
      let totalKm = 0
      let item = this.item
      let lineItems = []
      let totalTravelHours = 0
      item.cost = Number(item.baseRate)
      //lineItems.push(item)
      if(item.itemType === 'service') {
        total = Number(item.baseRate)
        // console.log(total)
        // distance related costs
          if ((this.itemCategory === 'serviceWithTravelTime')
              || (this.itemCategory === 'serviceWithMultipleStop'))
          {
            // console.log('serviceWithTravelTime calculated')
            if (this.travelTimeAndDistance) {
              totalKm = this.travelTimeAndDistance.meters/1000
              totalTravelHours = this.travelTimeAndDistance.seconds/3600
              //calculate additional km cost
              let distanceLineItem = {
                title: 'Distance Cost',
                created: Date.now(),
                cost: 0,
                qtyUnit: 'km',
                qty: 0,
                totalKm: totalKm,
                id: uuidv1()
              }
              if (totalKm > item.includedKm) {
                let additionalKm = totalKm - item.includedKm
                let additionalDistanceCost = additionalKm * +item.additionalKmRate
                distanceLineItem.qty = additionalKm
                distanceLineItem.cost = additionalDistanceCost
                total = total + additionalDistanceCost
              }
              // console.log(total)
              if (distanceLineItem.cost > 0) {
                lineItems.push(distanceLineItem)
              }
              totalHours += totalTravelHours
            } else {
              return this.getTravelTimeAndDistanceData()
            }
          }
          // addon items time factor
        let additionalTimelLineItem = {
          title: 'Additional Time',
          created: Date.now(),
          cost: 0,
          qty: 0,
          qtyUnit: 'hour',
          id: uuidv1()
        }
        let addOnItemTime = 0
          if (this.addOnItems.length !== 0) {
            this.addOnItems.forEach(addon => {

              return addOnItemTime += addon.qty * Number(addon.timeFactor)
            })
          }
          let extraAddonTime = (addOnItemTime/60) - (item.includedHours - totalTravelHours)
        if (extraAddonTime > 0) {
          let extraAddOnCost = extraAddonTime * item.costPerAdditionalUnit
          additionalTimelLineItem.qty = Number(extraAddonTime).toFixed(2)
          additionalTimelLineItem.cost = Number(extraAddOnCost).toFixed(2)
          lineItems.push(additionalTimelLineItem)
        }
        // console.log(+addOnItemTime/60)
        totalHours += +addOnItemTime/60
      }
      // product total calculations
      if(item.itemType === 'product') {
        // base rate
        if (item.qty > 1) {
          total = Number(item.baseRate) + (item.qty - 1) * Number(item.costPerAdditionalUnit)
          // console.log(item.baseRate)
        } else {
          total = item.baseRate * item.qty
        }
        if ((this.itemCategory === 'productWithDelivery')
            || (this.itemCategory === 'productWithMultipleStop')){
          // console.log('productWithDelivery calculated')
          //distance calculations
          if (this.travelTimeAndDistance) {
            totalKm = this.travelTimeAndDistance.meters/1000
            totalTravelHours = this.travelTimeAndDistance.seconds/3600
            //calculate additional km cost
            let distanceLineItem = {
              title: 'Distance Cost',
              created: Date.now(),
              cost: 0,
              qty: 0,
              qtyUnit: 'km',
              totalKm: totalKm,
              id: uuidv1()
            }
            if (totalKm > item.includedKm) {
              let additionalKm = totalKm - item.includedKm
              let additionalDistanceCost = additionalKm * +item.additionalKmRate
              distanceLineItem.qty = additionalKm
              distanceLineItem.cost = additionalDistanceCost
              total = total + additionalDistanceCost
            }
            if (distanceLineItem.cost > 0) {
              lineItems.push(distanceLineItem)
            }
            totalHours += totalTravelHours
          } else {
            return this.getTravelTimeAndDistanceData()
          }

        }
      }
      //calculate additional hours cost
      if (totalHours > item.includedHours) {
        let additionalTime = totalHours - item.includedHours
        let additionalTimeCost = additionalTime * +item.costPerAdditionalUnit
        total += Number(additionalTimeCost)
      }
      // console.log(total)
      // console.log(item)
      let finalCost = total * item.finalCostMultiplier
      if (item.additionalCost.length !== 0) {
        item.additionalCost.forEach(cost => {
          lineItems.push(cost)
          return finalCost += cost.cost
        })
      }
      let totalEstimate = Number(finalCost).toFixed(2)
      this.setLineItems(lineItems)
      // console.log('Distance: '+ totalKm)
      // console.log('Time: '+ totalHours)
      // console.log('Cost: '+ totalEstimate)
      return totalEstimate
    },
    formattedTimeAndDistance () {
      let totalHours = 0
      let totalDistance = 0

      if (this.travelTimeAndDistance) {
        let totalTravelHours = this.travelTimeAndDistance.seconds/3600
        totalHours += totalTravelHours
        totalDistance = this.travelTimeAndDistance.meters/1000
      }
      let addOnItemTime = 0
      if (this.addOnItems.length !== 0) {
        this.addOnItems.forEach(addon => {
          return addOnItemTime += addon.qty * addon.timeFactor
        })
      }
      totalHours += +addOnItemTime/60
      return {
        totalHours: Number(totalHours).toFixed(0) + ' hr',
        totalDistance: Number(totalDistance).toFixed(0) + ' km'
      }
    },
    totalListCost () {
      let lineItems = this.customerLineItems
      let cost = 0
      if (lineItems) {
        lineItems.forEach(item => {
          cost += +this.calcLineItemCost(item)
          // console.log(cost)
        })
      }
      let costRounded = Number(cost).toFixed(2)
      return costRounded
    }
  },
  created () {
    let db = this.$store.state.db
    let user = this.user
    // console.log(user)
    if (user) {
      if (user.uid) {
        if (user.deliveryLocation) {
          this.deliveryLocation = user.deliveryLocation
        }
        if (user.additionalLocations) {
          this.additionalLocations = user.additionalLocations
        }
      }
    }
    let itemRef = doc(db, 'publicListings', this.publicListingId + '/listings/' + this.listingId + '/items/' + this.itemId)
    onSnapshot(itemRef, res => {
      if (res.exists) {
        let data = res.data()
       // console.log(data)
        let item = data
        // setting item category
        // Categories:
        // productWithPickup, productWithDelivery, productWithMultipleStop, onlineOnly
        // serviceAtBaseRate, serviceWithTravelTime, serviceWithMultipleStop
        if(item.itemType === 'service') {
          this.displayOnly = true
          if (item.calcTravelTime) {
            this.displayOnly = false
            this.itemCategory = 'serviceWithTravelTime'
            if (item.additionalLocationsEnabled) {
              this.itemCategory = 'serviceWithMultipleStop'
            }
          } else {
            this.itemCategory = 'serviceAtBaseRate'
          }
          if (user) {
            if (user.addOnItems) {
              this.addOnItems = user.addOnItems
            } else {
              if (item.addOnItems) {
                this.addOnItems = item.addOnItems
              }
            }
          }
        }
        if(item.itemType === 'product') {
          this.displayOnly = true
          if (item.pickupLocationEnabled) {
            this.displayOnly = false
            this.itemCategory = 'productWithPickup'
            if (item.onlineOnly) {
              this.itemCategory = 'onlineOnly'
            }
            this.pickUpItemSwitch = true
          }
          if (item.deliveryEnabled){
            this.displayOnly = false
            this.itemCategory = 'productWithDelivery'
            if (item.additionalLocationsEnabled){
              this.itemCategory = 'productWithMultipleStop'
            }
          }
          if (item.deliveryEnabled && item.pickupLocationEnabled){
            // console.log('pick up drop off optional')
            item.pickUpDeliveryOptional = true
          }
        }
        this.itemType = item.itemType
        this.item = item;
        if (this.deliveryLocation) {
          // console.log(this.deliveryLocation)
          // console.log(this.item.startingLocations)
          this.getTravelTimeAndDistanceData()
        }

        let listingItems = this.$store.getters.listingItems
        if (!listingItems) {
          let itemsRef = collection(db, 'publicListings', this.publicListingId + '/listings/' + this.listingId + '/items')
          onSnapshot(itemsRef, res => {
            // console.log(res)
            if (res && res.empty !== true) {
              let items = []
              let sortedItems = []
              res.forEach(doc => {
                let data = doc.data()
                items.push(data)
              })
              // console.log(items)
              sortedItems = items.sort((a, b) => a.title.localeCompare(b.title))
              this.items = sortedItems
              this.setSimilarAndVartionItems ()
              this.$store.dispatch('setListingItems', sortedItems)
            }
            this.$store.dispatch('setLoading', false)
          })
        } else {
          this.items = listingItems
          this.setSimilarAndVartionItems()
        }


      }
      // this.deliveryLocation =  this.item.startingLocations[0]
      this.$store.dispatch('setLoading', false)
      // console.log(this.itemVariations)
      // console.log(this.similarItems)
    })

  },
  methods: {
    setSimilarAndVartionItems () {
      // console.log(this.items)
      let allItems = this.items
      if (allItems) {
        if (this.item.variationId) {
          let itemVariations = []
          allItems.forEach(item => {
           if (item.variationId === this.item.variationId) {
             return itemVariations.push(item)
           }
          })
          // console.log(itemVariations)
          if (itemVariations.length > 0) {
            this.itemVariations = itemVariations
          }
        }
        this.similarItems = this.items
      }
    },
    removeLineItem (lineItem) {
      console.log(lineItem)
      let index = this.customerLineItems.findIndex(local => {
        return local.id === lineItem.id
      })
      this.customerLineItems.splice(index, 1)
      this.user.lineItems = this.customerLineItems
      this.updatePreOrderData()
    },
    calcLineItemCost (item) {
      let cost = Number(item.cost)
      if (item.qty > 1) {
        cost = Number(item.baseRate) + (item.qty - 1) * item.costPerAdditionalUnit
      } else {
        cost = Number(item.baseRate)
      }
      if (item.sublineItems) {
        item.sublineItems.forEach(subItem => {
          cost += +subItem.cost
        })
      }
      cost = cost*item.finalCostMultiplier
      // console.log(item)
      let costRounded = Number(cost).toFixed(2)
      return costRounded
    },
    setLineItems (lineItems) {
      this.lineItems = lineItems
      this.lineItemsSize = lineItems.length
    },
    updateItems () {
      let filteredItem = this.addOnItems.find((filteredItem) => {
        return filteredItem.created === this.selectedItem.created
      })
      let filteredIndex = this.addOnItems.indexOf(filteredItem)
      this.addOnItems[filteredIndex] = this.selectedItem
      // console.log('updating quote')
      this.itemDialog = false
      this.user.addOnItems = this.addOnItems
      // this.reCalculateItemCost()
      this.updatePreOrderData()
    },
    openItemDialog (item) {
      this.itemDialog = true
      this.selectedItem = item
    },
    addItem (item) {
      // console.log(item)
      if (this.addOnItems) {
        item.created = Date.now()
        this.addOnItems.push(item)
      } else {
        this.addOnItems = []
        this.addOnItems.push(item)
      }
      this.user.addOnItems = this.addOnItems
      this.updatePreOrderData()

    },
    removeAddOnItem (addOnItem) {
      // console.log(item)
      let removedItem = this.addOnItems.find((item) => {
        return item.created === addOnItem.created
      })
      let index = this.addOnItems.indexOf(removedItem)
      this.addOnItems.splice(index, 1)
      this.user.addOnItems = this.addOnItems
      this.updatePreOrderData()
    },
    locationCountryRemoved (location) {
      // console.log(location)
      // let formattedLocation = location
      let formattedLocation = location.match(/^(?:[^,]*,){2}([^,]*)/)[0]
      return formattedLocation
    },
    saveToMyList () {
     let lineItem = {...this.item}
      // lineItem.locations = locationsArray
      lineItem.sublineItems = this.lineItems
      lineItem.id = uuidv1()
      if (this.user.lineItems) {
        this.user.lineItems.push(lineItem)
      } else {
        this.user.lineItems = []
        this.user.lineItems.push(lineItem)
      }
      for (let i = 0; i < lineItem.locations.length; i++) {
        //console.log(i)
        lineItem.locations[i].id = uuidv1() + '-' + i
        lineItem.locations[i].itemId = lineItem.id
      }
      if (this.addOnItems.length !== 0) {
        lineItem.addOnItems = this.addOnItems
      }
      // console.log(lineItem)
      // console.log(lineItem.locations)
      if (this.user.lineItems) {
        this.customerLineItems = this.user.lineItems
        this.lineItemsSize = this.user.lineItems.length
      }
      this.lineItemDialog = true
      this.updatePreOrderData()
    },
    bookOrderDirect () {
      let lineItem = {...this.item}
      // lineItem.locations = locationsArray
      lineItem.sublineItems = this.lineItems
      lineItem.id = uuidv1()
      if (this.user.lineItems) {
        this.user.lineItems.push(lineItem)
      } else {
        this.user.lineItems = []
        this.user.lineItems.push(lineItem)
      }
      for (let i = 0; i < lineItem.locations.length; i++) {
        //console.log(i)
        lineItem.locations[i].id = uuidv1() + '-' + i
        lineItem.locations[i].itemId = lineItem.id
      }
      if (this.addOnItems.length !== 0) {
        lineItem.addOnItems = this.addOnItems
      }
      // console.log(this.user.lineItems)
      // console.log(lineItem.locations)
      this.bookOrder()
    },
    bookOrder () {
      this.user.activeListingId = this.listingId
      this.$store.dispatch('setAnonUserData', this.user)
      let quoteId = uuidv1()
      // this.$store.dispatch('setListingId', this.listingId)
      console.log('route to smsAuth then on to orderBooking')
      // console.log(this.publicListingId)
      this.$router.push(
          '/checkSmsAuth/'
          + this.publicListingId
          + '/quote'
          + '/createQuote/'
          + quoteId
      )
    },
    changeItemVarient (item) {
      this.item = item
      this.$vuetify.goTo(10,
          {
            duration: 300,
            offset: 0,
            easing: 'easeInOutCubic'})
    },
    // location realted methods
    setFirstLocation (location) {
      //console.log(location)
      this.deliveryLocation = location
      let user = this.user
      user.deliveryLocation = location
      this.getTravelTimeAndDistanceData()
      this.updatePreOrderData()
    },
    removeFirstLocation () {
      if (this.additionalLocations.length !== 0) {
        this.deliveryLocation =  this.additionalLocations[0]
        this.user.deliveryLocation = this.deliveryLocation
        this.additionalLocations.splice(0, 1)
        this.user.additionalLocations = this.additionalLocations
      } else {
        this.deliveryLocation = null
        this.user.deliveryLocation = null
      }
      this.getTravelTimeAndDistanceData()
      this.updatePreOrderData()
    },
    addMoreLocations (location) {
      //console.log(this.additionalLocations)
      if (this.additionalLocations) {
        this.additionalLocations.push(location)
      } else {
        this.additionalLocations = []
        this.additionalLocations.push(location)
      }
      this.user.additionalLocations = this.additionalLocations
      this.getTravelTimeAndDistanceData()
      this.updatePreOrderData()
    },
    removeAdditionalLocation (location) {
      let index = this.additionalLocations.findIndex(local => {
        return local.created === location.created
      })
      this.additionalLocations.splice(index, 1)
      this.user.additionalLocations = this.additionalLocations
      this.getTravelTimeAndDistanceData()
      this.updatePreOrderData()
    },
    getTravelTimeAndDistanceData () {
      // console.log('in get travel time and distance')
      let locations = []
      let itemData = this.item
      // console.log(this.item.startingLocations)
      if (this.item.startingLocations.length > 0) {
        this.item.startingLocations.forEach(local => {
          locations.push({
            ...local,
            locationType: 'startingLocation'
          })
        })
      }
      // console.log(locations)
      if (this.deliveryLocation) {
        locations.push({
          ...this.deliveryLocation,
          locationType: 'deliveryLocation'
        })
      }
      // console.log(locations)
      if (this.additionalLocations.length !== 0) {
        this.additionalLocations.forEach(local => {
          locations.push({
            ...local,
            locationType: 'additionalLocation'
          })
        })
      }
       // console.log(locations)
      itemData.locations = locations

      if (locations.length > 1) {
        const functions = getFunctions()
        const getTravelTimeAndDistance = httpsCallable(functions, 'getTravelTimeAndDistance')

        return getTravelTimeAndDistance(itemData)
            .then(res => {
              this.travelTimeAndDistance = res.data.travelTimeAndDistance
              // console.log(res.data.travelTimeAndDistance)
            })
            .catch(err => {
              console.log(err)
            })
      } else {
        this.travelTimeAndDistance = null
      }
    },
    updatePreOrderData () {
      this.user.connectedPublicListingId  = this.publicListingId
      this.user.activeListingId = this.listingId
      let user = this.user
      let db = this.$store.state.db
      //console.log(this.user)
      if (user.isAnonymous) {
        this.$store.dispatch('setAnonUserData', user)
        let anonRef = doc(db, 'anonUsers', user.uid)
        return updateDoc(anonRef, user)
      } else {
        let customerRef = doc(db, 'customers', user.uid)
        return updateDoc(customerRef, user)
      }
    },
    openItemImage (img) {
      this.selectedImage = img
      this.itemImageDialog = true
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
  }
}
</script>
<style scoped>
.v-text-field .v-input__control .v-input__slot {
  min-height: 0 !important;
  padding: 0 8px !important;
  margin-bottom: 2px !important;
  display: flex !important;
  align-items: center !important;
}

</style>
